module.exports = __webpack_public_path__ + "./images/96ae869241b66092a95acdd39ca8cad3.webp";